<template>
  <form
    :class="className"
    :action="action"
    :method="method"
    @submit="onSubmit">
    <slot />
  </form>
</template>

<script>
import bemBlockModifiers from "@/utils/bem-block-modifiers";

export default {
  name: "FormComponent",
  props: {
    action: { type: String, default: null },
    method: { type: String, default: "GET" },
    modifiers: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    className() {
      return bemBlockModifiers("form", this.modifiers);
    }
  },
  methods: {
    onSubmit(event) {
      this.$emit("submit", event);
    }
  }
};
</script>
